import { render, staticRenderFns } from "./SupportSellerSelector.vue?vue&type=template&id=53983056&"
import script from "./SupportSellerSelector.vue?vue&type=script&lang=js&"
export * from "./SupportSellerSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports